<template>
  <DashboardLayout :menu-items="dashboardRoutesBaseOnAccess()">
    <div class="text-dashboard w-100 dashboard-home">
      <m-update-site-message-1/>

      <div class="dashboard-hero">
        <div>
          <p class="hero-kicker mb-1">{{ isAdmin ? 'داشبورد مدیریت' : 'داشبورد کاربری' }}</p>
          <h1>{{ welcomeTitle }}</h1>
          <p class="hero-desc">
            {{ isAdmin
              ? 'میانبرها، وضعیت سرویس و آمار فروش در همین صفحه.'
              : 'پروفایل، سفارش‌ها و میانبرهای پرکاربرد حساب کاربری.' }}
          </p>
        </div>
        <div class="dashboard-hero-badge">
          <i :class="isAdmin ? 'bi bi-speedometer2' : 'bi bi-person'"></i>
        </div>
      </div>

      <template v-if="isAdmin">
        <b-tabs pills align="center" class="text-center dashboard-tabs">
          <b-tab class="my-2" title="دسترسی سریع">
            <dashboard-quick-access/>
          </b-tab>
          <b-tab class="my-2" title="مدیریت" active>
            <dashboard-widget1/>
          </b-tab>
        </b-tabs>
      </template>

      <dashboard-quick-access v-else/>
    </div>
  </DashboardLayout>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {dashboardMenu, dashboardRoutesBaseOnAccess} from '../../routes/DashboardRoutes'
import DashboardLayout from '../../components/dashboard/Layout'
import DashboardWidget1 from "@/plugin/components/dashboard/DashboardWidget/DashboardWidget1.vue"
import DashboardQuickAccess from "@/plugin/components/dashboard/DashboardQuickAccess.vue"
import "@/plugin/components/dashboard/dashboard-home.css"

export default {
  name: "Dashboard",
  components: {
    DashboardWidget1,
    DashboardLayout,
    DashboardQuickAccess,
  },
  data() {
    return {
      dashboardMenu,
    }
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile",
      isAdmin: "User/isAdmin",
    }),
    welcomeTitle() {
      const name = ((this.profile && this.profile.name) || '').trim()
      if (name) {
        return name + '، خوش آمدید'
      }
      return 'خوش آمدید'
    },
  },
  methods: {
    dashboardRoutesBaseOnAccess,
    ...mapActions({
      logout: "Authentication/logout",
    }),
  },
  created() {
    this.$store.dispatch('HelpdeskTicket/fetchStatus')
  },
}
</script>

<style scoped>
.text-dashboard {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  margin: auto;
  padding: 8px 0 20px;
  background: transparent;
}

.dashboard-tabs >>> .tab-content,
.dashboard-tabs >>> .tab-pane {
  overflow-x: hidden;
  max-width: 100%;
}
</style>
